import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasObjectProperty from './aidas-object-property';
import AidasObjectPropertyDetail from './aidas-object-property-detail';
import AidasObjectPropertyUpdate from './aidas-object-property-update';
import AidasObjectPropertyDeleteDialog from './aidas-object-property-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasObjectPropertyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasObjectPropertyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasObjectPropertyDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasObjectProperty} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasObjectPropertyDeleteDialog} />
  </>
);

export default Routes;
